import {
  ITerraceLedSpots,
  ITerraceMarquee,
  ITerraceMeasure,
  ITerraceSidewall,
} from '../../utility/interface/terraceCover.interface'

export abstract class Status {
  /**
   * Tells if the suiteScene is displayed
   * @param measure The measure context values
   * @param sidewall The sidewall context values
   * @returns Whether the suiteScene is displayed or not
   */
  public static suiteScene(
    measure: ITerraceMeasure,
    sidewall: ITerraceSidewall
  ) {
    const glassRight = !(
      sidewall.sidewallRight === '1-teiliger Keil' ||
      sidewall.sidewallRight === '2-teiliger Keil' ||
      sidewall.sidewallRight === '3-teiliger Keil' ||
      sidewall.sidewallRight === '- Ohne Seitenwand rechts -'
    )

    const glassLeft = !(
      sidewall.sidewallLeft === '1-teiliger Keil' ||
      sidewall.sidewallLeft === '2-teiliger Keil' ||
      sidewall.sidewallLeft === '3-teiliger Keil' ||
      sidewall.sidewallLeft === '- Ohne Seitenwand links -'
    )

    const minWidth = measure.userWidth < 400

    return (glassRight && minWidth) || (glassLeft && minWidth)
  }

  /**
   * Tells if ledSpots are chosen
   * @param ledSpots The ledSpots context values
   * @returns If ledSpots are chosen
   */
  public static ledSpots(ledSpots: ITerraceLedSpots) {
    return !ledSpots.type.includes('ohne')
  }

  /**
   * Tells if a marquee is chosen
   * @param marquee The marquee context values
   * @returns If a marquee option is chosen
   */
  public static engine(marquee: ITerraceMarquee) {
    return !marquee.engine.includes('ohne')
  }

  /**
   * Tells if sidewallFront is chosen
   * @param sidewall The sidewall context values
   * @returns If a sidewallFront option is chosen
   */
  public static sidewallFront(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallFront?.includes('- Ohne Wand vorn -')
  }

  /**
   * Tells if sidewallRight is chosen
   * @param sidewall The sidewall context values
   * @returns If a sidewallRight option is chosen
   */
  public static sidewallRight(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallRight?.includes('- Ohne Seitenwand rechts -')
  }

  /**
   * Tells if sidewallRight schraeg is chosen
   * @param sidewall The sidewall context values
   * @returns If sidewallRight schraeg is chosen
   */
  public static sidewallSlantedRight(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallRight === 'Rahmenwand, schräg'
  }

  /**
   * Tells if sidewallLeft schraeg is chosen
   * @param sidewall The sidewall context values
   * @returns If sidewallLeft schraeg is chosen
   */
  public static sidewallSlantedLeft(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallLeft === 'Rahmenwand, schräg'
  }

  /**
   * Tells if sidewallLeft is chosen
   * @param sidewall The sidewall context values
   * @returns If a sidewallLeft option is chosen
   */
  public static sidewallLeft(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallLeft?.includes('- Ohne Seitenwand links -')
  }

  /**
   * Tells if lower right side windows are needed
   * @param sidewall The sidewall context values
   * @returns If the lower right side windows are needed
   */
  public static glassSideRight(sidewall: ITerraceSidewall) {
    return (
      sidewall?.sidewallRight !== '1-teiliger Keil' &&
      sidewall?.sidewallRight !== '2-teiliger Keil' &&
      sidewall?.sidewallRight !== '3-teiliger Keil'
    )
  }

  /**
   * Tells if lower left side windows are needed
   * @param sidewall The sidewall context values
   * @returns If the lower right side windows are needed
   */
  public static glassSideLeft(sidewall: ITerraceSidewall) {
    return (
      sidewall?.sidewallLeft !== '1-teiliger Keil' &&
      sidewall?.sidewallLeft !== '2-teiliger Keil' &&
      sidewall?.sidewallLeft !== '3-teiliger Keil'
    )
  }

  /**
   * Tells if the sidewallFront option includes tuer
   * @param sidewall The sidewall context values
   * @returns If the sidewallFront option includes tuer
   */
  public static sidewallDoorFront(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallFront?.includes('Glasschiebewand')
  }

  /**
   * Tells if the sidewallRight option includes tuer
   * @param sidewall The sidewall context values
   * @returns If the sidewallRight option includes tuer
   */
  public static sidewallDoorRight(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallRight?.includes('Glasschiebewand')
  }

  /**
   * Tells if the sidewallLeft option includes tuer
   * @param sidewall The sidewall context values
   * @returns If the sidewallLeft option includes tuer
   */
  public static sidewallDoorLeft(sidewall: ITerraceSidewall) {
    return sidewall?.sidewallLeft?.includes('Glasschiebewand')
  }

  /**
   * Tells if vsGlass options can be applied
   * @param measure The measure context values
   * @returns If the vsGlass options can be applied
   */
  public static vsGlass(measure: ITerraceMeasure) {
    return measure.userModel === 'DARI'
  }

  /**
   * Tells if the terrace cover is attached to the wall
   * @param measure The measure context values
   * @returns If the terrace cover is attached to the wall
   */
  public static wall(measure: ITerraceMeasure) {
    return measure.attach === 'detached'
  }
}
